module.exports = __webpack_public_path__ + "img/user.46c989fe.png";